import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

/**
 * Komponent SVG dla obszaru A - hatchback widok lewy
 */
export const AreaA_Hatchback_Left: React.FC<AreaSVGProps> = ({
  fill = '#73C69B',
  stroke = '#73C69B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="94"
      height="132"
      viewBox="0 0 94 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_a_hatchback_left"
          x="0"
          y="0"
          width="94"
          height="132"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>

      <g filter="url(#filter_area_a_hatchback_left)">
        <path
          d="M65.0205 4.07357e-06C66.0676 0.835154 67.0221 1.53268 67.8447 2.09571C68.9916 2.96649 70.4082 3.57106 71.999 3.58594C73.6672 3.60149 75.1472 2.96359 76.2822 1.98243C76.458 1.83052 76.6238 1.67039 76.7822 1.50489C76.9649 2.23852 77.139 2.9627 77.3047 3.66797C82.6043 26.2907 88.9964 81.049 93.1924 129.881C62.2721 124.697 24.7091 126.715 0.208998 131.408C0.204478 131.327 0.199848 131.245 0.195326 131.162C0.127244 129.919 0.060331 128.561 1.33734e-05 127.256C19.4771 125.723 35.5385 121.095 47.4258 111.613C60.2394 101.393 67.6063 86.022 69.7197 64.6084L69.7354 64.4531L69.7383 64.2969C70.0381 49.662 68.037 35.2103 59.1719 21.1123L65.0205 4.07357e-06Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
